import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SessionService } from '@monsido/core/session/session.service';

@Injectable({
    providedIn: 'root',
})
export class ZendeskProvider {
    private loaded = false;

    constructor (
        @Inject(DOCUMENT) private document: Document,
        private sessionService: SessionService,
    ) {}

    addScript (): void {
        if (this.shouldStartZendesk()) {
            this.initScript(this.sessionService.getChatSystemOptions());
        }
    }

    private shouldStartZendesk (): boolean {
        return !this.loaded;
    }

    private setupWidget (): void {
        try {
            if ((window as any).zE) {
                (window as any).zE('messenger', 'hide');
                (window as any).zE('messenger:on', 'close', function () {
                    (window as any).zE('messenger', 'hide');
                });
            }
        } catch (e) {
            setTimeout(() => this.setupWidget(), 100);
        }
    }

    private initScript (options?: any): void {
        if (options) {
            const zendeskScript = this.document.createElement('script');
            zendeskScript.nonce = 'POIVxjtpTiXk';
            zendeskScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + options.key;
            zendeskScript.id = 'ze-snippet';

            const script = this.document.createElement('script');
            script.type = 'text/javascript';
            script.nonce = '0MLgjJQShXrb';
            script.innerHTML = ' window.zESettings = ' + decodeURI(options.settings);

            this.loaded = true;
            this.document.body.appendChild(zendeskScript);
            this.document.body.appendChild(script);
            this.setupWidget();
        }
    }
}
